import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const typeApi = createApi({
  reducerPath: 'typeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Type'],
  endpoints: (builder) => ({
    getTypes: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/type',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Type'],
    }),
    addType: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-type',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Type'],
    }),
    updateType: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-type',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Type'],
    }),
    deleteType: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-type',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Type'],
    }),
  }),
});

export const {
  useGetTypesQuery,
  useAddTypeMutation,
  useUpdateTypeMutation,
  useDeleteTypeMutation,
} = typeApi;
